import React, { useState, useEffect } from "react";
import PMCLinkedModulesForm from "./PMCLinkedModulesForm";
import PMCLinkedModulesFormTransferCredit from "./PMCLinkedModulesFormTransferCredit";
import PMCAlreadyEnrolled from "./components/PMCAlreadyEnrolled";
import {
  GetProgressionSubjectsCancelToken,
} from "../../../../services/RegistrationService";
import axios from "axios";
function PMCLinkedForm(props) {
  const { regStatus, loadingNSData, setLoadingNsData, setBtnDissable,setCreditText, setPMCModulesSelected, opportunityIds, customErr } = props ? props : {};
  const [loading, setLoading] = useState(false);
  const [creditModules, setCreditModules] = useState([]);  
  const [progressionData, setProgressionData] = useState([]);  
  const [allModules, setAllModules] = useState([]);
  const [showModules,setShowModules] = useState({
    redo: {
      core: false,
      core_data: [],
    },
    progression: {
      core: false,
      core_data: [],
    },
    credit: {
      core: false,
      core_data: []
    }
  });
  const [adminRedoModulesIds, setAdminRedoModulesIds] = useState(props?.studentData?.re_reg_data?.admin_redo?.split(',') ?? []);
  const [adminCreditModulesIds, setAdminCreditModulesIds] = useState(props?.studentData?.re_reg_data?.admin_credit_modules?.split(',') ?? []);
  const [adminProgressionModulesIds, setAdminProgressionModulesIds] = useState(props?.studentData?.re_reg_data?.admin_progression?.split(',') ?? []);
  useEffect(() => {
    
    // create cancel token
    const source = axios.CancelToken.source();
    const cancelTokenSources = [];
    // save the source so we can cancel the request later
    cancelTokenSources.push(source);
    
    let selectedModules = [];
    if(props?.studentData?.re_reg_data?.live_portal_user_id && 
      props?.studentData?.re_reg_data?.latest_enrolment_netsuite_id)
      {
        setLoading(true);
        setBtnDissable("PosttoNetsuite")
        // Handle adminRedoModulesIds
        if (adminRedoModulesIds?.length > 0) {
          adminRedoModulesIds.forEach(id => {
            // return module id with netsuite id id        
            let module = progressionData?.redoModules?.find(module => String(module.netsuite_product_id) === String(id));
            if (module) {
              selectedModules.push(module?.module_id); // Push only module_id
            }
          });
        }
        
        const data = {
          "studentId": props?.studentData?.re_reg_data?.live_portal_user_id,
          "netsuiteProductId": props?.studentData?.re_reg_data?.latest_enrolment_netsuite_id,
          "selectedModules": selectedModules
        };
        
        GetProgressionSubjectsCancelToken(data, source.token)
        .then((success) => {
          setProgressionData(success?.data?.responseData || {});
          // if((regStatus == 'Re-Registration' || regStatus == 'Re-Registration Rejected')){          
          //   setCreditModules(success?.data?.responseData?.transferModules);
          // }else{
            let netsuiteIds = props?.studentData?.re_reg_data?.admin_credit_modules ? 
          props?.studentData?.re_reg_data?.admin_credit_modules.split(",") : 
          props?.studentData?.re_reg_data?.credit_modules ? 
          props?.studentData?.re_reg_data?.credit_modules.split(",") : 
          [];
          let allModules = Object.values(success?.data?.responseData?.AllModules || {});
          let creditModulesFound = [];
          // if(allModules?.length > 0 && netsuiteIds && netsuiteIds.length > 0){
          //   // find modules in allModules where netsuit_product_id in netsuiteIds
          //   for (let i = 0; i < netsuiteIds.length; i++) {
          //     let module = allModules?.find(module => String(module.netsuite_product_id) === String(netsuiteIds[i]));
          //     if (module) {
          //       creditModulesFound.push(module);
          //     }
          //   }
          // }
          // setCreditModules(creditModulesFound);   
          setCreditModules(Object.values(allModules) || []);    
          setAllModules(Object.values(allModules) || []);     
          // }
          setTimeout(() => setLoading(false), 500);
          setBtnDissable("")
        })
        .catch((error) => {
          console.log("<OpenRegistrationTab> -> </getProgressionSubject>: Error: " + error);
          setTimeout(() => setLoading(false), 500);
          setBtnDissable("")
        });
      };
      // Cleanup on unmount or when cancelTokenSources changes
      return () => {
        cancelTokenSources.forEach(source => source.cancel());
      };
    }, [props?.studentData?.re_reg_data?.live_portal_user_id, props?.studentData?.re_reg_data?.latest_enrolment_netsuite_id]);   
    useEffect(() => {    
      setPMCModulesSelected({
        "admin_redo": adminRedoModulesIds,
        // "admin_transfer_modules": adminTransferModulesIds,
        "admin_credit_modules": adminCreditModulesIds,
        "admin_progression": adminProgressionModulesIds,
      });
      // console.log("Redo", adminRedoModulesIds);
      // console.log("Credit", adminCreditModulesIds);
      // console.log("Progression", adminProgressionModulesIds);
    },[adminRedoModulesIds, adminCreditModulesIds,  adminProgressionModulesIds])
    
    useEffect(
      () => {
        if(progressionData){
          let updates = {
            redo: {
              core: false,
              core_data: [],
            },
            progression: {
              core: false,
              core_data: [],
            },
            credit: {
              core: false,
              core_data: [],
            }
          };
          let transferModulesData = progressionData?.transferModules;
          if (!props?.studentData?.re_reg_data?.admin_credit_modules || props?.studentData?.re_reg_data?.admin_credit_modules === null) {
            if (transferModulesData && transferModulesData.length > 0) {
              setAdminCreditModulesIds(
                transferModulesData
                  .filter(module => module.optional == 0)
                  .map(module => String(module.netsuite_product_id))
              );
            }
          } else {
            setAdminCreditModulesIds(props?.studentData?.re_reg_data?.admin_credit_modules ?
              props?.studentData?.re_reg_data?.admin_credit_modules.split(",") :
              props?.studentData?.re_reg_data?.credit_modules ?
                props?.studentData?.re_reg_data?.credit_modules.split(",") :
                []);
          }
          let allModules = Object.values(progressionData?.AllModules || {});

          if (progressionData?.redoModules && progressionData?.redoModules?.length > 0) {
            updates.redo = { ...updates.redo, core: true };
            progressionData.redoModules.forEach(module => {
              updates.redo.core_data = [...updates.redo.core_data, module];
            });
          }
          let netsuiteIds = props?.studentData?.re_reg_data?.admin_credit_modules ?
            props?.studentData?.re_reg_data?.admin_credit_modules.split(",") :
            props?.studentData?.re_reg_data?.credit_modules ?
              props?.studentData?.re_reg_data?.credit_modules.split(",") :
              [];
          let creditModulesFound = [];
          if (allModules?.length > 0 && netsuiteIds && netsuiteIds.length > 0) {
            // find modules in allModules where netsuit_product_id in netsuiteIds
            for (let i = 0; i < netsuiteIds.length; i++) {
              let module = allModules?.find(module => String(module.netsuite_product_id) === String(netsuiteIds[i]));
              if (module) {
                creditModulesFound.push(module);
              }
            }
          }
          if (creditModulesFound?.length > 0) {
            updates.credit = { ...updates.credit, core: true };
            creditModulesFound.forEach(module => {
              updates.credit.core_data = [...updates.credit.core_data, module];
            });
          }
          // }


          if (progressionData?.progression && progressionData?.progression?.length > 0) {
            updates.progression = { ...updates.progression, core: true };
            progressionData.progression.forEach(module => {
              updates.progression.core_data = [...updates.progression.core_data, module];
            });
          }
          setShowModules(prevState => ({
            ...prevState,
            ...updates
          }));
          // console.log("updates", updates);
        }
      }, [progressionData]
    );

      return (
        <>
        <div className="card-body">
        <div className="theme-form application-form">
        <div className="row">
        <div className="form-group col-sm-12 inputfield">
        {(adminRedoModulesIds?.length > 0 || showModules?.redo?.core || true) && (
          <PMCLinkedModulesForm
          setAdminModules={setAdminRedoModulesIds}
          selectedData={props.studentData?.re_reg_data?.admin_redo}
          allModules={allModules}
          moduleType={'redo'}
          readOnly={(regStatus != 'Re-Registration' && regStatus != 'Re-Registration Rejected')}
          />
        )
        }
        {(adminProgressionModulesIds?.length > 0 || showModules?.progression?.core) && (
          <PMCLinkedModulesForm
          setAdminModules={setAdminProgressionModulesIds}
          selectedData={props.studentData?.re_reg_data?.admin_progression}
          allModules={allModules}
          moduleType={'progression'}
          readOnly={(regStatus != 'Re-Registration' && regStatus != 'Re-Registration Rejected')}
          />
        )
        }
        <div className="form-group col-sm-12 inputfield">
        {(customErr) ? (
          <span className="">
          <p className="errorMsg">{customErr}</p>
          </span>
        ) : null}                
        </div>
        {adminCreditModulesIds?.length > 0 && (   
          <PMCLinkedModulesFormTransferCredit 
          setBtnDissable={setBtnDissable}
          creditModules={creditModules}
          loadingNSData={loadingNSData}
          setLoadingNsData={setLoadingNsData}
          loading={loading} 
          opportunityIds={opportunityIds}  
          setCreditText={setCreditText}
          setAdminCreditModulesIds={setAdminCreditModulesIds} 
          adminCreditModulesIds={adminCreditModulesIds}
          readOnly={(regStatus != 'Re-Registration' && regStatus != 'Re-Registration Rejected')}
          />
        )}
        {(regStatus == "Re-Registration" || regStatus == "Re-Registration Rejected") && (
          <PMCAlreadyEnrolled
          failedModules={progressionData?.failedModules}
          selectedData={progressionData?.modulesAlreadyEnrolled}
          allModules={progressionData?.AllModules}
          adminCreditModulesIds={adminCreditModulesIds}
          setAdminCreditModulesIds={setAdminCreditModulesIds}
          readOnly={(regStatus != 'Re-Registration' && regStatus != 'Re-Registration Rejected')}
          />
        )}
        </div>            
        </div>
        </div>
        </div>
        </>
      );
    }
    export default PMCLinkedForm;
    